import { BaseEntity } from './common';

// Common currency list for dropdown
export const CURRENCY_OPTIONS = [
  { code: 'MYR', symbol: 'RM', name: 'Malaysian Ringgit' },
  { code: 'INR', symbol: '₹', name: 'Indian Rupee' },
  { code: 'USD', symbol: '$', name: 'US Dollar' },
  { code: 'EUR', symbol: '€', name: 'Euro' },
  { code: 'GBP', symbol: '£', name: 'British Pound' },
  { code: 'SGD', symbol: 'S$', name: 'Singapore Dollar' },
  { code: 'AED', symbol: 'د.إ', name: 'UAE Dirham' },
  { code: 'SAR', symbol: '﷼', name: 'Saudi Riyal' },
  { code: 'THB', symbol: '฿', name: 'Thai Baht' },
  { code: 'IDR', symbol: 'Rp', name: 'Indonesian RBankingah' },
  { code: 'PHP', symbol: '₱', name: 'Philippine Peso' },
  { code: 'VND', symbol: '₫', name: 'Vietnamese Dong' },
  { code: 'BDT', symbol: '৳', name: 'Bangladeshi Taka' },
  { code: 'PKR', symbol: 'Rs', name: 'Pakistani Rupee' },
  { code: 'LKR', symbol: 'Rs', name: 'Sri Lankan Rupee' },
];

/** PKR uses a readable text prefix; the trailing space also fixes compact usages such as `${symbol}${amount}`. */
export const normalizeCurrencySymbol = (currency?: string, symbol?: string) =>
  currency?.toUpperCase() === 'PKR' || symbol?.trim() === '₨' || symbol?.trim() === 'Rs'
    ? 'Rs '
    : (symbol || 'RM');

export const DEFAULT_STORE_TIMEZONE = 'Asia/Kuala_Lumpur';

export const TIMEZONE_OPTIONS = [
  'Asia/Kuala_Lumpur',
  'Asia/Karachi',
  'Asia/Kolkata',
  'Asia/Dhaka',
  'Asia/Colombo',
  'Asia/Singapore',
  'Asia/Dubai',
  'Asia/Riyadh',
  'Asia/Bangkok',
  'Asia/Jakarta',
  'Asia/Manila',
  'Europe/London',
  'America/New_York',
  'America/Los_Angeles',
  'UTC',
];

// Store types
export interface StoreDTO extends BaseEntity {
  store_id: string;
  name: string;
  billPrefix?: string;
  currency?: string;
  currencySymbol?: string;
  timezone?: string;
  created_by: string; // user id
  createdByName?: string; // populated user name
}

export interface CreateStoreDTO {
  store_id: string;
  name: string;
  currency?: string;
  currencySymbol?: string;
  timezone?: string;
}

export interface UpdateStoreDTO extends Partial<CreateStoreDTO> {}

// Store API response types
export interface StoreListResponse {
  data: StoreDTO[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

// Backend pagination response type
export interface StorePaginationResponse {
  data: StoreDTO[];
  pagination: {
    currentPage: number;
    totalPages: number;
    totalItems: number;
    pageSize: number;
    hasNext: boolean;
    hasPrev: boolean;
  };
}

// Store form types
export interface StoreFormData {
  store_id: string;
  name: string;
  currency?: string;
  currencySymbol?: string;
  timezone?: string;
}

// Store state types
export interface StoreState {
  items: StoreDTO[];
  loading: boolean;
  error: string | null;
  currentPage: number;
  totalPages: number;
  totalItems: number;
  itemsPerPage: number;
  hasNext?: boolean;
  hasPrev?: boolean;
}
